import { useNavigate } from 'react-router';
import useDynamicState from './useDynamicState';
import getFilterString from '../function/getFilterString';
import PripomienkyListFilter from '../../../model/filter/PripomienkyListFilter';
import MultiChoiceItem from '../../../types/MultiChoiceItem';
import useDynamicArrayState from './useDynamicArrayState';
import getAllMultichoiceData from '../function/getAllMultichoiceData';
import {
  hromadnaTypPripomienkyMultichoice,
  obycajnaTypPripomienkyMultichoice,
} from '../../../model/pripomienka/TypPripomienky';
import { stavPripomienkyMultichoice } from '../../../model/pripomienka/StavPripomienky';
import FilterData from '../../../model/filter/FilterData';
import useMultichoiceInFilter from './useMultichoiceInFilter';

type ReturnType = {
  text: string;
  setText: (text: string) => void;
  from: Date;
  setFrom: (date: Date) => void;
  to: Date;
  setTo: (date: Date) => void;
  typ: MultiChoiceItem[];
  setTyp: (typ: MultiChoiceItem[]) => void;
  stav: MultiChoiceItem[];
  setStav: (typ: MultiChoiceItem[]) => void;
  priradeny: MultiChoiceItem[];
  isNepriradeny: boolean;
  setPriradeny: (typ: MultiChoiceItem[]) => void;
  pripomienkujuciSubjekt: MultiChoiceItem[];
  setPripomienkujuciSubjekt: (typ: MultiChoiceItem[]) => void;
  resetFilterHandler: () => void;
  targetUrl: string;
  isSelectedFilter: boolean;
};

export default (
  isHromadna: boolean,
  page: number,
  perPage: number,
  filter: PripomienkyListFilter,
  routeList: string,
  filterData: FilterData,
  fetchOdoslanaExists: boolean,
  setFetchOdoslanaExists?: (fetchOdoslanaExists: boolean) => void,
):
    ReturnType => {
  const [text, setText] = useDynamicState(filter.text);
  const [from, setFrom] = useDynamicState(filter.from);
  const [to, setTo] = useDynamicState(filter.to);
  const [typ, setTyp] = useDynamicArrayState(isHromadna
    ? getAllMultichoiceData(filter.typ, hromadnaTypPripomienkyMultichoice)
    : getAllMultichoiceData(filter.typ, obycajnaTypPripomienkyMultichoice));
  const [stav, setStav] = useDynamicArrayState(getAllMultichoiceData(filter.stav, stavPripomienkyMultichoice));
  const [pripomienkujuciSubjekt, setPripomienkujuciSubjekt] = useDynamicArrayState(getAllMultichoiceData(
    filter.pripomienkujuciSubjekt,
    filterData.pripomienkujuciSubjektList,
  ));
  const {
    values: priradeny,
    withoutValue: isNepriradeny,
    changeHandler: setPriradeny,
    resetValues: resetPriradeny,
  } = useMultichoiceInFilter(filter.priradeny, filterData.priradenyList, filter.isNepriradeny);
  const { targetUrl, isSelectedFilter } = getFilterString(
    page,
    perPage,
    text,
    from,
    to,
    typ,
    stav,
    priradeny,
    isNepriradeny,
    pripomienkujuciSubjekt,
    routeList,
  );
  const navigate = useNavigate();

  const resetFilterHandler = (): void => {
    setText(null);
    setFrom(null);
    setTo(null);
    setTyp(isHromadna ? hromadnaTypPripomienkyMultichoice : obycajnaTypPripomienkyMultichoice);
    setStav(stavPripomienkyMultichoice);
    resetPriradeny();
    setPripomienkujuciSubjekt(filterData.pripomienkujuciSubjektList);
    navigate(routeList);
    setFetchOdoslanaExists(!fetchOdoslanaExists);
  };

  return {
    text,
    setText,
    from,
    setFrom,
    to,
    setTo,
    typ,
    setTyp,
    stav,
    setStav,
    priradeny,
    isNepriradeny,
    setPriradeny,
    pripomienkujuciSubjekt,
    setPripomienkujuciSubjekt,
    resetFilterHandler,
    targetUrl,
    isSelectedFilter,
  };
};
